import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FunnelTemplate } from '@app/models/recruiting/funnel-template.model';
import { FunnelTemplateService } from '@app/modules/applicant-tracker/services';
import { RecruitingModuleMenuService } from '@app/modules/applicant-tracker/services/menus/recruiting-module-menu.service';
import { FunnelTemplatesIndexTable } from '@app/modules/applicant-tracker/services/tables/template-table/funnel-template-index.table';
import { MenuColumnEvent } from '@app/modules/table/interfaces/menu-column-event.interface';
import { AuthService, NotifyService } from '@app/services';

@Component({
    templateUrl: './funnel-templates-index.template.html',
    styleUrls: ['./funnel-templates-index.style.scss'],
})
export class FunnelTemplateIndex implements OnInit {
    funnelTemplate: FunnelTemplate;
    isTemplateDeleteModalOpen = false;
    table: FunnelTemplatesIndexTable;

    constructor(
        private funnelTemplateService: FunnelTemplateService,
        private router: Router,
        private notify: NotifyService,
        private auth: AuthService,
        public recruitingModuleMenuService: RecruitingModuleMenuService
    ) {}

    async ngOnInit(): Promise<void> {
        this.table = new FunnelTemplatesIndexTable(this.auth);
    }

    async menuAction(event: MenuColumnEvent): Promise<void> {
        const { menuItem, data } = event;
        this.funnelTemplate = data as FunnelTemplate;

        switch (menuItem.event) {
            case FunnelTemplatesIndexTable.edit.event:
                this.router.navigate(['/recruiting/templates/funnelTemplates/edit', this.funnelTemplate.id]);

                break;

            case FunnelTemplatesIndexTable.duplicate.event:
                try {
                    await this.funnelTemplateService.duplicate(this.funnelTemplate.id);
                    this.table.reload();
                    this.notify.success({
                        key: 'applicant-tracker.duplicatedFunnelTemplateName',
                        params: { name: this.funnelTemplate.name },
                    });
                } catch (err) {
                    this.notify.error({
                        key: 'applicant-tracker.duplicationFailedForTemplateName',
                        params: { name: this.funnelTemplate.name },
                    });
                }

                break;

            case FunnelTemplatesIndexTable.delete.event:
                this.isTemplateDeleteModalOpen = true;
                break;
        }
    }

    closeFunnelTemplateDeleteModal(): void {
        this.isTemplateDeleteModalOpen = false;
    }

    async onDeleteFunnelTemplate(): Promise<void> {
        try {
            await this.funnelTemplate.delete();
            this.table.reload();
            this.isTemplateDeleteModalOpen = false;
            this.notify.success({
                key: 'applicant-tracker.successfullyDuplicatedTemplate',
                params: { name: this.funnelTemplate.name },
            });
        } catch (err) {
            this.notify.error(err);
            this.isTemplateDeleteModalOpen = false;
        }
    }
}
